import Vue from 'vue'
import ElementUI from 'element-ui';
import Element from 'element-ui';
import animated from 'animate.css'

import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import 'normalize.css'
import  './assets/style.css'
import { jprouter , enrouter , weiborouter,beianmiit,beian} from "@/utils/common";

// import style (>= Swiper 6.x)
// import 'swiper/swiper-bundle.css'

Vue.use(Element, {
  size:'small' // set element-ui default size
})
Vue.use(ElementUI);
Vue.use(animated)

Vue.prototype.jprouter = jprouter
Vue.prototype.enrouter = enrouter
Vue.prototype.weiborouter = weiborouter
Vue.prototype.beian = beian
Vue.prototype.beianmiit = beianmiit
Vue.prototype.publicUrl = "http://api.dixcel.cn/dixcel"


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
